<template>
  <div class="edit-tag-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="400px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="params" :rules="rules" label-width="120px" label-position="left">
        <el-form-item label="封面:" prop="coverImg" v-if="false">
          <base-upload
            :cover="params.coverImg"
            :key="params.coverImg"
            :action="action"
            @successCallback="successCallback"
            :wSize="360"
            :hSize="360"
          ></base-upload>
        </el-form-item>
        <el-form-item label="标签名:" prop="name">
          <el-input v-model.trim="params.name" size="small" placeholder="请填写标签名称"></el-input>
        </el-form-item>
        <el-form-item label="描述:" prop="tagDesc" v-if="false">
          <el-input v-model.trim="params.tagDesc" size="small" placeholder="请填写标签描述"></el-input>
        </el-form-item>
        <el-form-item label="常用排序号:" prop="usedSortCode">
          <el-input v-model.number="params.usedSortCode" size="small"></el-input>
        </el-form-item>
        <el-form-item label="播放量(假):" prop="fakePlayCount" v-if="false">
          <el-input v-model.number="params.fakePlayCount" size="small"></el-input>
        </el-form-item>
        <el-form-item label="精彩排序号:" prop="wonderSortCode" v-if="false">
          <el-input v-model.number="params.wonderSortCode" size="small"></el-input>
        </el-form-item>
        <el-form-item label="是否片源标签:" prop="isSource">
          <el-switch v-model="params.isSource"></el-switch>
        </el-form-item>
        <el-form-item label="推送至精彩:" prop="isWonder" v-if="false">
          <el-switch v-model="params.isWonder"></el-switch>
        </el-form-item>
        <el-form-item label="是否常用:" prop="isCommonUsed">
          <el-switch v-model="params.isCommonUsed"></el-switch>
        </el-form-item>
        <el-form-item label="是否启用:" prop="isActive">
          <el-switch v-model="params.isActive"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm()" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {validatorIndex, validatorLanguage} from "@/utils/validator";
import API from "@/api";
import baseConfig from "@/utils/serverUrlConfig";

export default {
  data() {
    return {
      dialogVisible: false,
      title: "",
      type: "",
      // 提交状态
      flag: false,
      id: "",
      // 封面上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
      // 表单数据
      params: {
        coverImg: "",
        name: "",
        tagDesc: "",
        isWonder: false,
        isSource: false,
        isCommonUsed: false,
        isActive: false,
        fakePlayCount: 0,
        wonderSortCode: 0,
        usedSortCode:0
      },
      // 表单验证规则
      rules: {
        name: [
          { required: true, message: "请输入标签名称", trigger: "blur" },
          { validator: validatorLanguage, trigger: "blur" }
        ],
        sortKey: [
          { required: true, message: "请输入排序", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" }
        ],
        fakeRating: [
          { required: true, message: "请输入排序", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" }
        ],
        fakeCollCount: [
          { required: true, message: "请输入排序", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" }
        ],
        wonderSortCode: [
          { required: true, message: "请输入精彩排序", trigger: "blur" },
          { validator: validatorIndex, trigger: "blur" }
        ],
        coverImg: [{ required: false, message: "请上传封面图", trigger: "blur" }]
      }
    };
  },
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.flag = true;
          if (this.type === "add") {
            this.addTags();
          } else {
            this.editTag();
          }
        } else {
          return false;
        }
      });
    },
    // 添加标签
    addTags() {
      API.addTags(this.params)
        .then(res => {
          if (res.code === 200) {
            this.$message({
              message: "添加成功",
              type: "success"
            });
            this.$emit("handlerTagList");
          } else {
            this.$message.error("添加失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 编辑标签
    editTag() {
      if (this.params.coverImg == "" || this.params.coverImg == null) {
        this.params.coverImg = "xxx"
      }
      let params = Object.assign(this.params, { id: this.id });
      API.editTags(params)
        .then(res => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功",
              type: "success"
            });
            this.$emit("handlerTagList");
          } else {
            this.$message.error("编辑失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 标签封面上传成功回掉
    successCallback(res) {
      this.params.coverImg = res.data.coverImg;
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
      this.params = {
        coverImg: "",
        name: "",
        tagDesc: "",
        isWonder: false,
        isSource: false,
        isCommonUsed: false,
        isActive: false,
        fakePlayCount: 0,
        wonderSortCode: 0,
        usedSortCode:0
      };
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.dialogVisible = true;
      this.type = type;
      if (type === "edit") {
        this.title = "编辑标签";
        this.params=data
        this.id = data.id;
      } else {
        this.title = "新增标签";
      }
    }
  }
};
</script>

<style lang="scss" >
.edit-tag-box {
  .el-dialog {
    margin-top: 100px !important;
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .el-upload {
    width: 100%;
    height: 100%;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border: 1px dashed #e63765;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    &:hover {
      color: 1px dashed #e63765 !important;
    }
  }
}
</style>

